import { IAppState } from '../../../redux';
import { IFormattedPeriod } from '../../../redux/reducers';
import { selectActiveService } from '../selectActiveService';
import { formatPeriodName } from './formatPeriodName';

export function selectFormattedPeriods(state: IAppState): IFormattedPeriod[] {
  const selectedService = selectActiveService(state);

  if (!selectedService) {
    return [];
  }

  const {
    publishOptions: { periodIds, periods },
  } = selectedService;

  return periodIds.map(periodId => {
    const period = periods[periodId];

    return {
      value: period.id,
      label: formatPeriodName(period),
    };
  });
}
